import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-4 md:py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/5b0e55db21655eca8e03e44a17fcce4c.png"
            alt="EasyMarketPro"
            className="h-7 md:h-8 w-auto"
          />
          <span className="ml-2 text-[16px] md:text-[18px] font-bold text-[#B8985F] tracking-tight">EasyMarketPro</span>
        </Link>

        <div className="flex items-center gap-6 md:gap-8">
          <Link
            to="/"
            className={`text-[14px] font-medium transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-[#333] hover:text-[#B8985F]' : 'text-white hover:text-[#B8985F]'
            }`}
          >
            Home
          </Link>
          <a
            href="/#how-it-works"
            className={`text-[14px] font-medium transition-colors cursor-pointer whitespace-nowrap hidden sm:block ${
              scrolled ? 'text-[#333] hover:text-[#B8985F]' : 'text-white hover:text-[#B8985F]'
            }`}
          >
            How It Works
          </a>
          <a
            href="/#use-cases"
            className={`text-[14px] font-medium transition-colors cursor-pointer whitespace-nowrap hidden sm:block ${
              scrolled ? 'text-[#333] hover:text-[#B8985F]' : 'text-white hover:text-[#B8985F]'
            }`}
          >
            Use Cases
          </a>
          <Link
            to="/about"
            className={`text-[14px] font-medium transition-colors cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-[#B8985F]' : 'text-[#B8985F]'
            }`}
          >
            About
          </Link>
          <Link
            to="/book-a-call"
            className="px-6 py-2.5 bg-[#B8985F] text-black text-[14px] font-semibold rounded-md hover:bg-[#A68850] transition-all cursor-pointer whitespace-nowrap"
          >
            Book a Call
          </Link>
        </div>
      </div>
    </nav>
  );
}
